import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9b999b80"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=9b999b80&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports